import * as React from 'react'

interface ISystemBadge {
	count?: number, // number to be displayed on the badge
	icon?: string,	// class name of the icon 
	header?: React.ReactElement, // header to be displayed on the dropdown
	footer?: React.ReactElement, // footer to be displayed on the dropdown
	children?: React.ReactChildren
}

export const SystemBadge = (props: ISystemBadge) =>
	<li className="dropdown custom-dropdown notifications-menu">
		<a href="#" className="nav-link  b-l pl-lg-3 pr-lg-3" data-toggle="dropdown" aria-expanded="false">
			<i className={props.icon}></i>
			<span className="badge badge-danger badge-mini rounded-circle">props.count</span>
		</a>
		<ul className="dropdown-menu dropdown-menu-right">
			{props.header ? <li className="header">{props.header}</li> : <></>}
			{props.children ? <li>{props.children}</li> : <></>}
			{props.footer ? <li className="footer p-2 text-center">{props.footer}</li> : <></>}
		</ul>
	</li>


				//<ul className="menu">
				//	<li>
				//		<a href="#">5 new members joinedtoday</a>
				//	</li>
				//	<li>
				//		<a href="#">5 new members joined today</a>
				//	</li>
				//	<li>
				//		<a href="#">5 new members joined today</a>
				//	</li>
				//</ul>
